import { useTranslation } from './useModuleTranslation';

/**
 * Hook for accessing common translations shared across components
 * Loads 'common-ui' module which contains common UI translations
 */
export function useCommonTranslation() {
  return useTranslation('common-ui');
}